module.exports = __webpack_public_path__ + "static/media/404.deb340e9.svg";